// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { createElement, Fragment, HTMLAttributes } from 'react'

import { Link, Text } from '@doist/marketist'

import rehypeToc from '@jsdevtools/rehype-toc'
import { useTranslation } from 'next-i18next'
import rehypeParse from 'rehype-parse'
import rehypeReact from 'rehype-react'
import { unified } from 'unified'

import css from './html-renderer.module.css'

/** Render HTML content into React using the Twist design system. */
export function HtmlRenderer({ html }: { html: string }) {
    const { t } = useTranslation('common')
    return unified()
        .use(rehypeParse, { fragment: true })
        .use(rehypeToc)
        .use(rehypeReact, {
            Fragment: Fragment,
            createElement: createElement,
            components: {
                nav: (props: HTMLAttributes<HTMLDivElement>) => (
                    <details>
                        <Text tag="summary" size="body-base">
                            {t('tableOfContents')}
                        </Text>
                        <nav {...props} />
                    </details>
                ),
                a: (props: HTMLAttributes<HTMLAnchorElement>) => <Link {...props} />,
                p: (props: HTMLAttributes<HTMLElement>) => (
                    <Text tag="p" className={css.p} size="body-base" {...props} />
                ),
                h1: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h1} size="major-xl" tag="h1" {...props} />
                ),
                h2: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h2} size="major-lg" tag="h2" {...props} />
                ),
                h3: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h3} size="major-sm" tag="h3" {...props} />
                ),
                h4: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h4} size="minor-lg" tag="h4" {...props} />
                ),
                h5: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h5} size="minor-base" tag="h5" {...props} />
                ),
                h6: (props: HTMLAttributes<HTMLElement>) => (
                    <Text className={css.h6} size="minor-sm" tag="h6" {...props} />
                ),
                ul: (props: HTMLAttributes<HTMLElement>) => (
                    <Text tag="ul" size="body-base" className={css.ul} {...props} />
                ),
                ol: (props: HTMLAttributes<HTMLElement>) => (
                    <Text tag="ol" size="body-base" className={css.ol} {...props} />
                ),
                li: (props: HTMLAttributes<HTMLElement>) => (
                    <Text tag="li" size="body-base" className={css.li} {...props} />
                ),
            },
        })
        .processSync(html).result
}
